import "../css/About.css";

const About = () => {
  return (
    <main className="night-about">

      {/* INTRO */}
      <section className="about-intro">
        <div className="intro-text">
          <h1>
            About<br />Neo Café
          </h1>
          <p>
            Neo Café was created as a response to loud places,
            rushed mornings, and overstimulated spaces.
          </p>
        </div>

        <div className="intro-image" />
      </section>

      {/* STORY */}
      <section className="about-story">
        <div className="story-text">
          <h2>The Idea</h2>
          <p>
            We imagined a café that belongs to the night.
            A place where conversations slow down,
            where coffee isn’t rushed,
            and where silence feels intentional.
          </p>
        </div>

        <div className="story-image img-one" />

        <div className="story-image img-two" />

        <div className="story-text">
          <h2>The Atmosphere</h2>
          <p>
            Low light. Minimal interiors.
            Sound that stays in the background.
            Every detail designed to calm, not distract.
          </p>
        </div>
      </section>

      {/* STATEMENT */}
      <section className="about-statement">
        <h2>
          Not a café for everyone.<br />
          A café for the right moment.
        </h2>
      </section>

      {/* VALUES */}
      <section className="about-values">
        <div>
          <span>01</span>
          <h3>Intentional Design</h3>
          <p>
            Every material, light source,
            and surface has a reason to exist.
          </p>
        </div>

        <div>
          <span>02</span>
          <h3>Focused Coffee</h3>
          <p>
            A small menu built around
            bold espresso and balance.
          </p>
        </div>

        <div>
          <span>03</span>
          <h3>Night Culture</h3>
          <p>
            A space designed for thinkers,
            creatives, and late conversations.
          </p>
        </div>
      </section>

      {/* CLOSING IMAGE */}
      <section className="about-closing-image">
        <p>
          Neo Café is not about trends.<br />
          It’s about presence.
        </p>
      </section>

    </main>
  );
};

export default About;
